export const guideHeaderLinkDataTestId = 'guide-header-link-data-test-id';
export const referenceHeaderLinkDataTestId =
  'reference-header-link-data-test-id';
